export default __webpack_public_path__ + "static/media/reverseArrow.9fcf463c.svg";